import { Button, CircularProgress, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip, Box } from '@mui/material';
import { deleteObjectApi, getObjectListByPropertyApi } from 'api/general';
import { getSubjectName, highlightText, stripHTMLTags, swal_error } from 'app/utils/appHelpers';
import { DECISION, DECISION_FILE } from 'app/utils/constants/customConstant';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import PendingAgendaDataTableToolbar from './PendingAgendaDataTableToolbar';

function PendingAgendaDataTable({ handleAddPendingAgenda }) {

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [loading, setLoading] = useState(false);
  const subjectList = useSelector(state => state.subject.data || []);
  const allAuthorizedUnits = useSelector(state => state.auth.allAuthorizedUnits);
  const pageType = useSelector(state => state.meeting.pageType);
  const [highlightQuery, setHighlightQuery] = useState('');

  const column = [

    { id: 'department', align: 'left', disablePadding: false, label: "İlgili Kurum/Birim" },
    { id: 'subject', align: 'left', disablePadding: true, label: "Konu" },
    { id: 'agenda', align: 'left', disablePadding: true, label: "Gündem" },
    { id: 'decision', align: 'left', disablePadding: true, label: "Karar" },
    { id: 'pendingText', align: 'left', disablePadding: false, label: "Gerekçe" },
    { id: 'action', align: 'left', disablePadding: false, label: "İşlem" },

  ];


  useEffect(() => {
    const getAPI = async () => {
      setLoading(true);
      try {

        let agendas = [];
        agendas = await getObjectListByPropertyApi(DECISION, "meetingId", "-1");
        agendas = agendas.data;
        agendas = agendas.filter(agenda => agenda.pendingUnitId !== 0);

        let units = [];
        if (pageType === "1") {
          units = allAuthorizedUnits.filter(x => x.inst === "YK")
        } else if (pageType === "3") {
          units = allAuthorizedUnits.filter(x => x.inst !== "YK")
        }

        agendas = agendas.filter(agenda => units.map(unit => unit.id).includes(agenda.pendingUnitId));

        setData(agendas);
        setData2(agendas);


      } catch (error) {
        console.error("API Hatası: ", error);
      } finally {
        setLoading(false);
      }
    };

    getAPI();
  }, []);


  const handleRequestSort = (event, property) => {
    const tempOrderBy = property;
    let tempOrder = 'desc';

    if (orderBy === property && order === 'desc') {
      tempOrder = 'asc';
    }

    const tempdata =
      tempOrder === 'desc'
        ? data.sort((a, b) => (b[tempOrderBy] < a[tempOrderBy] ? -1 : 1))
        : data.sort((a, b) => (a[tempOrderBy] < b[tempOrderBy] ? -1 : 1));

    setData(tempdata);
    setOrder(tempOrder);
    setOrderBy(tempOrderBy);

  };

  const DataTableHead = ({ onRequestSort, customColumnData }) => {
    const createSortHandler = property => event => {
      onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
          {customColumnData.map(column => (
            <TableCell
              key={column.id}
              align={column.align}
              padding={column.disablePadding ? 'none' : 'normal'}
              sx={{ whiteSpace: 'normal', ...column.sx }}
            >
              <Tooltip
                title="Sırala"
                placement={column.align === 'right' ? 'bottom-end' : 'bottom-start'}
                enterDelay={300}
              >
                <TableSortLabel
                  active={orderBy === column.id}
                  direction={order}
                  onClick={createSortHandler(column.id)}
                  sx={{ whiteSpace: 'normal', '& .MuiTableSortLabel-icon': { flexShrink: 0 } }}
                >
                  {column.label}
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };


  const onAddPendingAgenda = async (item) => {
    if (handleAddPendingAgenda) {
      handleAddPendingAgenda(item);
    }
  };
  const onClickAddPending = async (n) => {
    await onAddPendingAgenda(n)
  };

  const onClickDeletePendingAgenda = async (agendaItem) => {
    const confirmResult = await Swal.fire({
      title: 'Silme İşlemi',
      text: 'Bu gündemi kalıcı olarak sileceksiniz. Bu işlem geri alınamaz. Devam etmek istiyor musunuz?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Evet',
      cancelButtonText: 'Vazgeç',
      customClass: { container: 'swal-container-custom' }
    });

    if (!confirmResult.isConfirmed) return;



    setLoading(true);
    try {
      const resFiles = await getObjectListByPropertyApi(DECISION_FILE, "decisionId", agendaItem.id);
      const decisionFileList = resFiles?.data || [];

      for (const fileItem of decisionFileList) {
        await deleteObjectApi(DECISION_FILE, fileItem.id);
      }

      await deleteObjectApi(DECISION, agendaItem.id);

      const nextData = data.filter(x => x.id !== agendaItem.id);
      setData(nextData);
      setData2(nextData);

      Swal.close();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Silme işlemi başarılı.',
        showConfirmButton: false,
        timer: 2000,
        customClass: { container: 'swal-container-custom' }
      });
    } catch (error) {
      console.error("Gündem silme API hatası: ", error);
      Swal.close();
      swal_error("Gündem silinirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", 4000);
    } finally {
      setLoading(false);
    }
  };



  return (
    <Paper className="col-md-12" sx={{ minWidth: 0, overflow: 'hidden' }}>

      <PendingAgendaDataTableToolbar
        pageTitle={"Askıdaki Gündemler"}
        data2={data2}
        setData={setData}
        loading={loading}
        setLoading={setLoading}
        setHighlightQuery={setHighlightQuery}
      />

      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <CircularProgress />
        </div>
      ) : (
        <>


          <div className="flex-auto" style={{ minWidth: 0 }}>
            <Box sx={{ overflowX: 'auto' }}>
              <Table
                className=""
                sx={{
                  minWidth: 960,
                  '& .MuiTableCell-head': { whiteSpace: 'normal' },
                  '& .MuiTableSortLabel-root': { whiteSpace: 'normal' },
                  '& .MuiTableSortLabel-icon': { flexShrink: 0 },
                }}
              >
                <DataTableHead
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  rowCount={data.length}
                  customColumnData={column}
                />

                <TableBody>
                  {data
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((n) => {


                      return (
                        <TableRow hover key={"trO" + n.id}>


                          <TableCell align="left" padding="normal" >
                            {n.department}
                          </TableCell>
                          <TableCell align="left" padding="none" >
                            {getSubjectName(n.subjectId, subjectList)}
                          </TableCell>
                          <TableCell align="left" padding="none" sx={{ whiteSpace: 'pre-line' }}>
                            {highlightText(stripHTMLTags(n.agenda), highlightQuery)}
                          </TableCell>
                          <TableCell align="left" padding="none" sx={{ whiteSpace: 'pre-line' }}>
                            {highlightText(stripHTMLTags(n.decision), highlightQuery)}
                          </TableCell>
                          <TableCell align="left" padding="normal">
                            {n.pendingText}
                          </TableCell>

                          <TableCell align="left" padding="none" >

                            <Tooltip title="Toplantıya Ekle">
                              <Button
                                variant="contained"
                                size="small"
                                sx={{ minWidth: 20, p: '5px', mr: 1 }}
                                onClick={() => onClickAddPending(n)}
                              >
                                Ekle
                              </Button>

                            </Tooltip>

                            <Tooltip title="Gündemi Sil">
                              <Button
                                variant="contained"
                                color="error"
                                size="small"
                                sx={{ minWidth: 20, p: '5px' }}
                                onClick={() => onClickDeletePendingAgenda(n)}
                              >
                                Sil
                              </Button>
                            </Tooltip>
                          </TableCell>

                        </TableRow>
                      );
                    })}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      count={data.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={(e, page) => setPage(page)}
                      onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
                      labelRowsPerPage={"Görüntülenecek Satır"}
                      rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                      showFirstButton
                      showLastButton
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Box>
          </div>



        </>
      )}
    </Paper>
  );
};

export default PendingAgendaDataTable;